(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // No search modal renders in this theme (both instances are disabled), so this
      // was throwing a TypeError on every scroll-down. Guard rather than refactor.
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Top-level header dropdowns: hover opens the panel, clicking follows the link.

    Both behaviours are layered on top of the native <details>/<summary> rather
    than replacing it, and DetailsDisclosure's focusout->close is left alone.

    Hover-to-open only runs where a real hovering pointer exists, so touch devices
    are unaffected. Click-to-navigate sends a pointer click anywhere on the summary
    to the parent link's href (Menu -> the All Meals collection) instead of
    toggling. Keyboard activation and touch taps keep the native toggle, so the
    submenu stays reachable without a hover.
  */
  (function () {
    var CLOSE_DELAY = 200; // ms - lets the pointer travel diagonally to the panel

    function hasFinePointer() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function bindHeaderMenu(root) {
      (root || document).querySelectorAll('.header__inline-menu details-disclosure > details').forEach(function (details) {
        if (details.dataset.headerMenuBound === 'true') return;
        details.dataset.headerMenuBound = 'true';

        var summary = details.querySelector('summary');
        if (!summary) return;

        var parentLink = summary.querySelector('.header__menu-parent-link');
        var parentUrl = parentLink ? parentLink.getAttribute('href') : '';
        var closeTimer;

        function open() {
          window.clearTimeout(closeTimer);
          if (details.hasAttribute('open')) return;
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
        }

        function scheduleClose() {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(function () {
            // Leave it open if focus is still inside, so keyboard users are not cut off.
            if (details.contains(document.activeElement)) return;
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }, CLOSE_DELAY);
        }

        if (hasFinePointer()) {
          details.addEventListener('mouseenter', open);
          details.addEventListener('mouseleave', scheduleClose);
          details.addEventListener('focusin', function () {
            window.clearTimeout(closeTimer);
          });
        }

        if (!parentUrl) return;

        summary.addEventListener('click', function (event) {
          // Enter/Space report detail 0. Leave those to the native toggle so the
          // submenu is still reachable by keyboard.
          if (event.detail === 0) return;

          if (!hasFinePointer()) {
            // Touch: a tap should open the panel, so cancel the link inside it.
            if (event.target.closest && event.target.closest('.header__menu-parent-link')) {
              event.preventDefault();
            }
            return;
          }

          // Modifier clicks: let the browser open the link its own way.
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          event.preventDefault(); // stops <details> from toggling
          window.location.href = parentUrl;
        });
      });
    }

    bindHeaderMenu(document);

    // Re-bind when the theme editor re-renders the header section.
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('.header__inline-menu')) {
        bindHeaderMenu(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-banner-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initMpkDeliveryCards(){
    document.querySelectorAll('[data-mpk-delivery-card]').forEach(function(card){
      if(card.dataset.mpkDeliveryBound==='true')return;
      card.dataset.mpkDeliveryBound='true';
      var cutoffRaw=card.getAttribute('data-cutoff')||'';
      var cutoffLabel=card.getAttribute('data-cutoff-label')||'';
      var autoCycle=card.getAttribute('data-mpk-auto-cycle')==='true';
      var cycle=(autoCycle && typeof window.mpkOrderCycle==='function')?window.mpkOrderCycle():null;
      var cutoff=cycle?cycle.cutoff:new Date(cutoffRaw);
      var cutoffValid=!Number.isNaN(cutoff.getTime());
      var dateNode=card.querySelector('.mpk-delivery-card__date');
      var cutoffNode=card.querySelector('.mpk-delivery-card__cutoff');
      var countdown=card.querySelector('[data-mpk-countdown]');
      var status=card.querySelector('[data-mpk-countdown-status]');
      var daysNode=card.querySelector('[data-mpk-days]');
      var hoursNode=card.querySelector('[data-mpk-hours]');
      var minutesNode=card.querySelector('[data-mpk-minutes]');
      var sectionId=card.getAttribute('data-section-id');
      var sticky=document.querySelector('[data-mpk-delivery-sticky][data-section-id="'+sectionId+'"]');
      var stickyDate=sticky?sticky.querySelector('strong'):null;
      var stickyCountdown=sticky?sticky.querySelector('[data-mpk-sticky-countdown]'):null;
      if(cycle){
        if(dateNode)dateNode.textContent=cycle.sundayHeading;
        if(cutoffNode)cutoffNode.textContent=cycle.cutoffText;
        if(stickyDate)stickyDate.textContent=cycle.sundayHeading;
        cutoffLabel=cycle.cutoffText;
      }
      function pad(value){return String(value).padStart(2,'0')}
      function applyCycle(){
        if(!autoCycle||typeof window.mpkOrderCycle!=='function')return;
        cycle=window.mpkOrderCycle();
        cutoff=cycle.cutoff;
        cutoffValid=!Number.isNaN(cutoff.getTime());
        if(dateNode)dateNode.textContent=cycle.sundayHeading;
        if(cutoffNode)cutoffNode.textContent=cycle.cutoffText;
        if(stickyDate)stickyDate.textContent=cycle.sundayHeading;
        cutoffLabel=cycle.cutoffText;
      }
      function renderCountdown(){
        applyCycle();
        if(!cutoffValid){if(countdown)countdown.hidden=true;if(status)status.textContent=cutoffLabel;if(stickyCountdown)stickyCountdown.textContent=cutoffLabel;return}
        var remaining=cutoff.getTime()-Date.now();
        if(remaining<=0){
          applyCycle();
          remaining=cutoff.getTime()-Date.now();
        }
        if(remaining<=0){if(countdown)countdown.hidden=true;if(status)status.textContent='Ordering cutoff has passed';if(stickyCountdown)stickyCountdown.textContent='Ordering cutoff has passed';return}
        var totalMinutes=Math.floor(remaining/60000);
        var days=Math.floor(totalMinutes/1440);
        var hours=Math.floor((totalMinutes%1440)/60);
        var minutes=totalMinutes%60;
        if(countdown)countdown.hidden=false;
        if(status)status.textContent='Time left to order';
        if(daysNode)daysNode.textContent=pad(days);
        if(hoursNode)hoursNode.textContent=pad(hours);
        if(minutesNode)minutesNode.textContent=pad(minutes);
        if(stickyCountdown)stickyCountdown.textContent=days+'d '+pad(hours)+'h '+pad(minutes)+'m left to order';
      }
      var stickyTicking=false;
      function updateSticky(){stickyTicking=false;if(!sticky)return;var shouldShow=card.getBoundingClientRect().bottom<0;sticky.hidden=!shouldShow;sticky.setAttribute('aria-hidden',shouldShow?'false':'true')}
      function requestStickyUpdate(){if(stickyTicking)return;stickyTicking=true;window.requestAnimationFrame(updateSticky)}
      renderCountdown();updateSticky();window.setInterval(renderCountdown,30000);window.addEventListener('scroll',requestStickyUpdate,{passive:true});window.addEventListener('resize',requestStickyUpdate);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initMpkDeliveryCards)}else{initMpkDeliveryCards()}
  document.addEventListener('shopify:section:load',initMpkDeliveryCards);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
